const SearchInputFilterContainerStyle = `
  align-content: center;
  grid-auto-flow: column;
  grid-column-gap: 15px;
  justify-content: start;
`;

export default SearchInputFilterContainerStyle;
